import React from "react";

// Public Terms of Service (/terms), linked from the Accept box on the client
// quote page and the acceptance email. Mainly for private (consumer)
// Automotive clients; Industrial work runs on the signed Service Contract.
// Changing the substance: bump TERMS_VERSION in api/_lib/quoteRespond.js and
// the version line below, so History records which version a client agreed to.

const VERSION = "v1 (October 2026)";

const S = {
  page: { minHeight: "100vh", background: "#f4f6fb", fontFamily: "'IBM Plex Sans', Helvetica, Arial, sans-serif", color: "#0e1520", padding: "32px 16px 56px" },
  card: { maxWidth: 760, margin: "0 auto", background: "#fff", borderRadius: 12, padding: "32px 28px", boxShadow: "0 1px 3px rgba(14,21,32,0.08)", lineHeight: 1.65, fontSize: 15 },
  h1: { fontSize: 26, margin: "0 0 4px", color: "#0e1520" },
  h2: { fontSize: 17, margin: "26px 0 8px", color: "#0e1520" },
  muted: { color: "#5a6a7a", fontSize: 13.5 },
  ol: { paddingLeft: 20, margin: "0 0 8px" },
};

export default function TermsPage() {
  return (
    <div style={S.page}>
      <div style={S.card}>
        <img src="/logo-dark.png" alt="Sublime Precision Cleaning" style={{ height: 30, width: "auto", display: "block", marginBottom: 22 }} />
        <h1 style={S.h1}>Terms of Service</h1>
        <div style={S.muted}>Vehicle preservation and dry ice cleaning · Version {VERSION}</div>

        <h2 style={S.h2}>1. Who we are</h2>
        <p>Sublime Precision Cleaning is a trading name of Way Out West Ltd, registered in England and Wales, company number 14772088, VAT number 429689047. Registered office: The Old School, Stennack, St Ives, Cornwall, TR26 1QU. Workshop: Unit 1C, Guildford Road Industrial Estate, Hayle, Cornwall, TR27 4QZ. Contact: hello@sublimeprecision.co.uk, 01736 804118.</p>

        <h2 style={S.h2}>2. Your quote and our agreement</h2>
        <ol style={S.ol}>
          <li>Your quote sets out the work, the price and what is not included. It is valid for 30 days from the date of issue.</li>
          <li>When you accept your quote, these terms and the quote together form our agreement.</li>
          <li>If we find something during the work that changes the scope or price (for example, corrosion that needs more treatment than quoted), we will stop and ask you before doing any extra work. We will never add a charge you haven’t agreed to.</li>
        </ol>

        <h2 style={S.h2}>3. Prices, deposit and payment</h2>
        <ol style={S.ol}>
          <li>Prices include VAT at the prevailing rate where shown as “inc VAT”.</li>
          <li>A 50% deposit secures your booking. We confirm your date once the deposit is paid.</li>
          <li>The balance is payable on collection for work at our workshop, or on completion for work at your location.</li>
        </ol>

        <h2 style={S.h2}>4. Your right to cancel</h2>
        <ol style={S.ol}>
          <li>If you accept your quote online, by email or by phone, you have 14 days from the day you accept to cancel for any reason. Tell us by email or phone; you don’t have to give a reason.</li>
          <li>If you cancel within those 14 days and no work has started, we refund your deposit in full within 14 days.</li>
          <li>If you ask us to start work within the 14 days and then cancel, we refund your deposit less a fair amount for the work done up to that point. Once the work is fully complete, the right to cancel no longer applies.</li>
          <li>After the 14 days, you can still move or cancel your booking. We’re a small workshop and a late cancellation usually leaves a slot we can’t refill, so the following applies to your deposit:
            <ul style={{ paddingLeft: 18, margin: "6px 0 0" }}>
              <li><strong>7 days’ notice or more</strong> before your booked date: we refund your deposit in full, or move it to a new date free of charge.</li>
              <li><strong>Between 2 and 7 days’ notice:</strong> we keep half your deposit (25% of the quote price) to cover the dry ice ordered and the booking we can’t refill, and refund the rest. Alternatively, you can move your booking once to a new date and we keep your full deposit towards it.</li>
              <li><strong>Less than 48 hours’ notice, or if the vehicle isn’t brought in</strong> on the booked date: we keep your deposit.</li>
            </ul>
          </li>
        </ol>

        <h2 style={S.h2}>5. Bookings and your vehicle</h2>
        <ol style={S.ol}>
          <li>Any date shown before your deposit is paid is provisional. If we have to move a confirmed date, we will tell you as soon as we can and offer the next available date or a full refund.</li>
          <li>Please remove valuables and personal items, and tell us about any known faults, leaks, modifications or previous repairs before the work starts.</li>
          <li>We take reasonable care of your vehicle while it is with us, and we hold public liability insurance.</li>
          <li>Dry ice cleaning removes dirt, grease and loose or failed coatings. It can reveal existing corrosion, damage or poor previous repairs that were hidden underneath. We will show you anything significant we find, with photos, but we are not responsible for defects that existed before the work.</li>
          <li>We take photos for our records. We only use photos of your vehicle in our marketing if you have agreed to it.</li>
        </ol>

        <h2 style={S.h2}>6. Protection products and guarantees</h2>
        <p>Any protection system and guarantee is described in your quote. How long a protection system lasts depends on how the vehicle is used and stored. Where a guarantee depends on inspections, the vehicle must attend each one for the guarantee to continue.</p>

        <h2 style={S.h2}>7. If something isn’t right</h2>
        <p>Please tell us within 14 days of collection or completion and we will look at it and put it right where the work is at fault. This doesn’t affect your legal rights as a consumer.</p>

        <h2 style={S.h2}>8. Your details</h2>
        <p>We use the details you give us only to quote for, book, carry out and invoice your work, and to contact you about it. We don’t sell or share them for marketing.</p>

        <h2 style={S.h2}>9. The law</h2>
        <p>These terms are governed by the law of England and Wales.</p>

        <p style={{ ...S.muted, marginTop: 28 }}>Questions about these terms? Email hello@sublimeprecision.co.uk or call 01736 804118.</p>
      </div>
    </div>
  );
}
